import { AbstractControl, ValidatorFn } from '@angular/forms';
import { isEmpty, isFinite, toNumber } from 'lodash';
import { StringAnyMap } from 'src/app/core/models/common.models';
import { CustomField } from 'src/app/core/models/custom-fields.models';
import { IdeaCustomFieldValue } from 'src/app/core/models/idea.models';

export const getNumberValidator = (field: CustomField): ValidatorFn => {
  return (control: AbstractControl): StringAnyMap | null => {
    if (field.type !== 'NUMBER') return null;

    const val: IdeaCustomFieldValue = control.value;
    if (isEmpty(val.value)) return null;

    const num = toNumber(val.value);

    let message = '';
    if (!isFinite(num)) {
      message = 'Value must be a number';
    } else if (typeof field.max === 'number' && num > field.max) {
      message = 'Value cannot be larger than ' + field.max;
    } else if (typeof field.min === 'number' && num < field.min) {
      message = 'Value cannot be less than ' + field.min;
    }

    return message ? { number: { message } } : null;
  };
};
